import posthog from "posthog-js";
import { env } from "./env";

/**
 * Initialize PostHog analytics and feature flags.
 * Should be called once when the app starts.
 */
export function initPostHog(): void {
  if (!env.VITE_POSTHOG_KEY) {
    if (import.meta.env.DEV) {
      console.info("[PostHog] No API key configured - analytics disabled");
    }
    return;
  }

  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST,
    // Capture page views automatically
    capture_pageview: true,
    // Capture page leaves for session recording
    capture_pageleave: true,
    // Disable in development unless explicitly enabled
    loaded: (ph) => {
      if (import.meta.env.DEV && !env.VITE_POSTHOG_DEV_ENABLED) {
        ph.opt_out_capturing();
      }
    },
    // Bootstrap feature flags on load for faster first render
    bootstrap: {
      featureFlags: {},
    },
    // Persist across sessions
    persistence: "localStorage+cookie",
  });
}

/**
 * Check if PostHog is initialized and capturing.
 * @returns Whether PostHog is enabled and capturing
 */
export function isPostHogEnabled(): boolean {
  return Boolean(env.VITE_POSTHOG_KEY) && !posthog.has_opted_out_capturing();
}

export { posthog };
